/**
 * Created by Ivan on 01.01.2025
 */

const CupTimer = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.options = options || {};

        const styles = cleverapps.styles.CupTimer;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles);

        this.timer = new Timer(this.options.timeLeft);
        this.addChild(this.timer);
        this.timer.setAlignment(this.width / 2, this.height / 2);

        this.textNode = this.createTextNode(this.options.text);
        this.addChild(this.textNode);
        this.textNode.setAlignment(this.width / 2, this.height / 2);
    },

    createTextNode: function (label) {
        const styles = cleverapps.styles.CupTimer;

        const textBg = new cc.Scale9Sprite(bundles.small_timer.frames.small_timer_bg_png);
        textBg.setContentSize2(styles.textNode);

        const text = this.text = cleverapps.UI.generateOnlyText(label, cleverapps.styles.FONTS.WHITE_TEXT);
        textBg.addChild(text);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);
        text.fitTo(textBg.width - 2 * styles.textNode.padding.x, textBg.height - 2 * styles.textNode.padding.y);
        text.setAlignment(textBg.width / 2, textBg.height / 2);

        return textBg;
    },

    showTimer: function (timeLeft) {
        this.textNode.setVisible(false);
        this.timer.setVisible(true);
        this.timer.resetTimeLeft(timeLeft);
    },

    showText: function (text) {
        const styles = cleverapps.styles.CupTimer;
        this.text.setString(text || this.options.text);
        this.text.fitTo(this.textNode.width - 2 * styles.textNode.padding.x, this.textNode.height - 2 * styles.textNode.padding.y);
        this.textNode.setVisible(true);

        this.timer.setVisible(false);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DAILY_CUP_TIMER_TEXT: {
        name: "default",
        color: cleverapps.styles.COLORS.WHITE,
        size: 40,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.CupTimer = {
    width: 300,
    height: 100,

    timer: {
        bg: {
            width: 270,
            height: 55
        }
    },

    textNode: {
        width: 400,
        height: 80,

        padding: {
            x: 10,
            y: 5
        }
    }
};